<template>
  <div class="addons">
    <div class="header">
      <h6
        data-testid="license-addons-features--title"
        class="ibf-h6 ib-color-text-grey"
      >
        {{ $t('license.addons.title') }}
      </h6>
    </div>
    <div class="addons-body ibf-text-list2">
      <q-scroll-area
        :thumb-style="{ borderRadius: '3px', width: '6px', background: 'rgba(127, 135, 137, 0.4)', right: '0px', opacity: 1 }"
        class="features-wrapper"
      >
        <p
          data-testid="license-addons--title"
          class="ibf-text-list1 ib-color-text-grey"
        >
          Packages:
        </p>
        <p
          v-for="addonFeature in getFeatures.addons"
          :key="addonFeature"
          :data-cy-license-addon="addonFeature"
        >
          {{ addonFeature }}
        </p>
        <p
          data-testid="license-features--title"
          class="ibf-text-list1 ib-color-text-grey margin-top"
        >
          Features
        </p>
        <p
          v-for="productFeature in getFeatures.features"
          :key="productFeature"
          :data-cy-license-feature="productFeature"
        >
          {{ productFeature }}
        </p>
      </q-scroll-area>
    </div>
  </div>
</template>

<script>
import { useLicenseAddonAndProductQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import COLORS from '@/design-system/colors.json';

export default defineComponent({
  name: 'LicenseAddonsFeatures',
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const GQL_userLicenseAddonAndProduct = useLicenseAddonAndProductQuery(() => ({
      coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
    }));
    return { GQL_userLicenseAddonAndProduct, COLORS };
  },
  computed: {
    getFeatures() {
      let addons = [];
      let features = [];
      const { addonFeatures, productFeatures } = this.addonAndProductFeatures;
      if (productFeatures) features = productFeatures.trim().split(',');

      if (addonFeatures) addons = addonFeatures.trim().split(',');
      return { addons, features };
    },
    addonAndProductFeatures() {
      return this.GQL_userLicenseAddonAndProduct?.result?.value?.ibManagerEntities?.license?.windows?.features || {};
    },
  },
});
</script>

<style lang="scss" scoped>
.addons {
  flex-grow: 1;
  width: 100%;
  margin-top: 57px;
  background-color: $-system-app-background;
  border: 1px solid #f0f3f4;
  border-radius: 2px;

  & .header {
    & h6 {
      margin: 0;
      padding: 8px 32px;
    }
    background-color: $-system-app-grey-95;
  }
  & .addons-body {
    height: calc(100% - 50px);
    min-height: 270px;
    overflow-y: hidden;

    & .features-wrapper {
      height: 100%;
    }

    & p {
      margin-bottom: 8px;
      &.margin-top {
        margin-top: 20px;
      }
    }
    padding: 32px;
    padding-right: 0;
  }
}
</style>
